import { render, staticRenderFns } from "./TeamInviteNameEmail.vue?vue&type=template&id=c0722654&scoped=true"
import script from "./TeamInviteNameEmail.vue?vue&type=script&lang=js"
export * from "./TeamInviteNameEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0722654",
  null
  
)

export default component.exports